export function Section6Tour() {
  return (
    <div className="copy-block narrow" data-motion="reveal">
      <p className="eyebrow mono">THE TERMINAL</p>
      <h2>Eight tabs. One operator.</h2>
      <p>
        Atlas, Overview, Charts, Risk, Fundamentals, Brief, Terminal, and Portfolio
        stay inside the existing dashboard. The landing shell only opens the door.
      </p>
      <div className="callout-list mono">
        <span>Atlas: cross-sectional signal</span>
        <span>Risk: correlations and drawdowns</span>
        <span>Brief: source-labeled news</span>
      </div>
    </div>
  )
}
